/**
 * TexturePacker atlas stems on Vercel Blob (`animations/pvp-characters/{stem}.json` + `.png`).
 * Keep aligned with uploaded files (same names as former `public/.../battle-character/`).
 */
export const PVP_BATTLE_IDLE_ATLAS_PRELOAD_STEMS: readonly string[] = [
  'archera-idle-back',
  'archera-idle-front',
  'bruxus-idle-back',
  'bruxus-idle-front',
  'bula-idle-back',
  'bula-idle-front',
  'caeloria-idle-back',
  'caeloria-idle-front',
  'finza-idle-back',
  'finza-idle-front',
  'hayate-idle-back',
  'hayate-idle-front',
  'korthas-idle-back',
  'korthas-idle-front',
  'motoko-idle-back',
  'motoko-idle-front',
  'nytheris-idle-back',
  'nytheris-idle-front',
  'rena-idle-back',
  'rena-idle-front',
  'sakura-idle-back',
  'sakura-idle-front',
  'solvarion-idle-back',
  'solvarion-idle-front',
  'valyra-idle-back',
  'valyra-idle-front',
  'vitalis-idle-back',
  'vitalis-idle-front',
]
